/**
 * API URL utilities - auto-detect correct backend URL
 * This ensures the frontend uses the correct API URL even on production
 */

// Smart API URL detection - use current origin on production, env var for development
export const getApiUrl = () => {
  // В браузере всегда ходим на текущий origin: nginx на сервере проксирует
  // /api на бэкенд того же домена. Так собранный бандл не привязан к
  // конкретному домену (раньше здесь был список прежних адресов) и
  // одинаково работает на любом, куда его развернули.
  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location;
    const isLocalDev = hostname === 'localhost' || hostname === '127.0.0.1';
    if (!isLocalDev) {
      return origin;
    }
  }
  // Локальная разработка: фронт на localhost:3000, бэкенд поднят отдельно.
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Export default API URL
export const API_URL = getApiUrl();

/**
 * Normalize a media/image URL so it always resolves against the CURRENT host.
 * Historically some image URLs were saved as absolute links to old preview
 * domains (e.g. https://sauna-catalog.preview.emergentagent.com/api/uploads/xxx).
 * Those 404 on production. The underlying file lives in the app's own DB and is
 * served from /api/uploads/ on whatever host we're on, so we rewrite any such
 * absolute link to the current backend origin. External URLs (imgur, cloudinary,
 * data URIs) are returned untouched.
 */
export const resolveMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('data:')) return url;
  const base = getApiUrl();
  // Relative path served by our backend
  if (url.startsWith('/api/uploads/') || url.startsWith('/api/static/')) {
    return `${base}${url}`;
  }
  // Absolute URL that points at our upload/static route on some (possibly stale) host
  const marker = url.indexOf('/api/uploads/') !== -1
    ? '/api/uploads/'
    : (url.indexOf('/api/static/') !== -1 ? '/api/static/' : null);
  if (marker && /^https?:\/\//i.test(url)) {
    const path = url.slice(url.indexOf(marker));
    return `${base}${path}`;
  }
  return url;
};

export default API_URL;

/** fetch с токеном — для мест, где вызов написан не через axios.
 *
 *  Перехватчик axios сюда не достаёт, а маршруты заказов теперь требуют
 *  входа: без заголовка калькулятор молча не откроет заказ на правку.
 */
/**
 * Токен прикладываем ТОЛЬКО к своим адресам.
 *
 * Иначе однажды `authFetch` позовут к Cloudinary или к чужому API — и наш
 * `Bearer` уедет туда вместе с запросом. Заголовок, приложенный «на всякий
 * случай», утекает молча: ошибки нет, ответ приходит, и заметить нечем.
 *
 * Своим считаем относительный путь и тот же origin, что у страницы.
 */
export const nashAdres = (url) => {
  const s = String(url || '');
  if (s.startsWith('/')) return true;
  if (!/^https?:\/\//i.test(s)) return true;   // относительный без ведущей косой
  try {
    return new URL(s).origin === (API_URL || window.location.origin);
  } catch {
    return false;
  }
};

// Заголовок с токеном для тех мест, где ходят голым `axios`, а не
// `authFetch`. Ключ хранилища назван здесь ОДИН раз нарочно: он уже
// разъехался — 47 мест читают `authToken` (его и кладёт вход), а четыре
// читают `token`, которого не кладёт никто, и шлют пустой заголовок.
// Беда тихая: сервер отвечает 401, а выглядит это как «не сохранилось».
export const zagolovokTokena = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const authFetch = (url, options = {}) => {
  const token = localStorage.getItem('authToken');
  const headers = { ...(options.headers || {}) };
  if (token && !headers.Authorization && nashAdres(url)) {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(url, { ...options, headers });
};
